export const metaDataElement = (metadataRoot, ...propertyNames) => {
    const metadata = [];

    metadata.push({ _: { $Ref: `${metadataRoot.type || 'content'}/${metadataRoot.id}` } });

    if (propertyNames) {
        propertyNames.forEach((property) => {
            property &&
                metadata.push({
                    _: `properties.${property}`,
                });
        });
    }
    return JSON.stringify(metadata);
};

export const metaDataProperty = (property) => {
    const metadata = [];
    metadata.push({ _: `properties.${property}` });
    return JSON.stringify(metadata);
};

export const metaDataForResponsiveDevices = () => {
    const metadata = [
        {
            cm_responsiveDevices: {
                mobile_portrait: { width: 414, height: 736, order: 1, isDefault: 'true' },
                mobile_landscape: { width: 736, height: 414, order: 2 },
                tablet_portrait: { width: 768, height: 1024, order: 3 },
                tablet_landscape: { width: 1024, height: 768, order: 4 },
            },
            cm_preferredWidth: 1200,
        },
    ];
    return { 'data-cm-metadata': JSON.stringify(metadata) };
};
